<template>
    <div class="equip-box box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="box-head">
            <div style="color:#0378F5;">
                {{pageName}}
            </div>
          
        </div>
        <div class="box-main">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
            >
                <el-table-column
                  fixed
                  label="名称"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column 
                  v-for="(item,index) in tableData[0].list" 
                  :key="index" 
                  :label="item.columnName"
                >
                    <template>
                        <span v-if="item.type=='1'">{{item.val}}</span>
                        <span v-if="item.type=='2'">
                            <el-image v-if="item.val && ''!=item.val" style="width: 100px; height: 100px" :src="urlHttp+item.val" :preview-src-list="[urlHttp+item.val]"></el-image>
                            <img v-else src="../../../assets/image/zanwutupian.png" style="height: 100px;" />
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handEdit(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
          :title="macTitle"
          :visible.sync="dataVisible"
          center
          :append-to-body="true"
          :lock-scroll="false"
          width="30%"
        >
            <el-form
                :model="macData"
                ref="macData"
                label-width="160px"
                label-position="right"
            >
                <el-form-item :label="item.columnName+'：'" v-for="(item,index) in macData.list" :key="index">
                    <el-input v-if="item.type=='1'" v-model="item.val" autocomplete="off" style="width:220px"></el-input>
                    <el-upload
                        v-else-if="item.type=='2'"
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :headers="uploadHead"
                        :data={type:238}
                        accept="image/*"
                        :objectBind='item.index'
                        :on-success="fileSuccess"
                    >
                        <img v-if="item.val" :src="urlHttp+item.val" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dataVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitMac()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            id:'',
            tableData:[{}],
            groupId:'',
            urlHttp:base.httpCtx,
            dataVisible:false,
            macTitle:'',
            macData:{
                name:'',
                list:[]
            },
            uploadUrl:base.url + '/upload/uploadPhoto', //上传地址
            uploadHead:{  //上传接口header
                accessToken:util.session.get('token')
            },
            pageName:'',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        this.getDate()
    },
    methods:{
        getDate(){
            var that = this
            myHttp.getProTemplateData({id:this.id}).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proTemplateData
                    var list = []
                    if(data.columnsData){
                        var colList = JSON.parse(data.columnsData)
                        var obj = {
                            name:data.name,
                            id:data.id,
                            facilityId:data.facilityId,
                            templateId:data.templateId,
                            list:colList
                        }
                    }else{
                        var obj = {
                            name:data.name,
                            id:data.id,
                            facilityId:data.facilityId,
                            templateId:data.templateId,
                            list:[]
                        }
                    }
                    list.push(obj)
                    that.tableData = list
                    that.pageName = data.name
                }
            })
        },
        //编辑
        handEdit(row){
            this.dataVisible = true
            this.macTitle = row.name
            this.macData = row
        },
        fileSuccess(res, file,opt,other){
            if(res.code == 200){
                for(var i=0;i<this.macData.list.length;i++){
                    if(other == this.macData.list[i].index){
                        this.macData.list[i].val = res.data.saveUrls
                    }
                }
                var list = this.macData.list
                this.macData.list = []
                this.macData.list = list
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //提交
        sumbitMac(){
            var that = this
            myHttp.updateProTemplateData({
                id:this.macData.id,
                columnsData:JSON.stringify(this.macData.list),
                name:this.macData.name,
                facilityId:this.macData.facilityId,
                updateBy:util.session.get('user').id,
                templateId:this.macData.templateId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('提交成功')
                    that.getDate()
                    that.dataVisible = false
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },
     
    }
}
</script>

<style scoped>
    .equip-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .box-head{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-between;
        padding: 0 1vw;
        background: #fff;
    }
    .box-main{
        width: 100%;
        height: calc( 100% - 8vh );
        position: relative;
        background: #fff;
    }
</style>

<style>
    .equip-box .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .equip-box .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .equip-box .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .equip-box .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .avatar{
        width: 100%
    }
    @import '../../../assets/css/common.css';
</style>